export const DashboardPannel = ({ size = "16" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_108_5553)">
      <path
        d="M9.50033 8C9.50033 8.67933 9.29499 9.30933 8.94566 9.836L6.83366 7.724V4.734C8.35499 5.04267 9.50033 6.38733 9.50033 8ZM5.50033 4.734C3.97899 5.04267 2.83366 6.38733 2.83366 8C2.83366 9.84067 4.32633 11.3333 6.16699 11.3333C6.84633 11.3333 7.47633 11.128 8.00299 10.7787L5.50033 8.276V4.734ZM10.8337 6H13.5003V4.66667H10.8337V6ZM10.8337 8.66667H13.5003V7.33333H10.8337V8.66667ZM10.8337 11.3333H13.5003V10H10.8337V11.3333ZM16.167 4V14H0.166992V4C0.166992 2.89733 1.06433 2 2.16699 2H14.167C15.2697 2 16.167 2.89733 16.167 4ZM14.8337 4C14.8337 3.63267 14.535 3.33333 14.167 3.33333H2.16699C1.79899 3.33333 1.50033 3.63267 1.50033 4V12.6667H14.8337V4Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_5553">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.166992)"
        />
      </clipPath>
    </defs>
  </svg>
);
